/**
 * Created by Ning Jiang on 3/3/2018.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineLite, TweenLite} from "gsap";
import {WildNudgeStrings} from "../../../WildNudgeStrings";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class WildNudgeFreespinOutroView extends ScreenView {

    private _container:PIXI.Container;
    private _bgLights:PIXI.Sprite;
    private _youWonTitle:PIXI.Text;
    private _youWonAmount:PIXI.BitmapText;
    private _fsCountTitle:PIXI.Text;

    private _mainTimeline:TimelineLite;

    // #317, maintained in scope of "this", since tl is created only once.
    private _totalWinBelowStake: boolean = false;

    private _youWonTitleStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "57px",
        fontWeight : "700",
        fill : "#e1e2d7",
        dropShadowColor : "#000000",
        dropShadow : true,
        dropShadowAngle : 90,
        dropShadowDistance : 6,
        stroke : "#000000",
        strokeThickness : 7,
    };

    private _fsCountStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "30px",
        fontWeight : "700",
        fill : "#e1e2d7",
        dropShadowColor : "#000000",
        dropShadow : true,
        dropShadowAngle : 90,
        dropShadowDistance : 6,
        stroke : "#000000",
        strokeThickness : 7,
    };

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }

    protected initAnimations():void {
        super.initAnimations();
        this.resetScreen();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();

        this._bgLights = new PIXI.Sprite(GameResources.getTextures("freespinLights")[0]);
        this._bgLights.anchor.set(0.5, 0.5);
        this._bgLights.blendMode = PIXI.BLEND_MODES.ADD;

        /**Left tip of some characters are cut if there is no space added at the beginning. example: "je winst" in dutch for "you won"
         Might be something regarding pixi text.*/
        this._youWonTitle = new PIXI.Text(` ${Translation.translate(WildNudgeStrings.FS_YOU_WON_TEXT)} `, this._youWonTitleStyle);
        this._youWonTitle.anchor.set(0.5, 0.5);
        this._youWonTitle.position.set(0, -145);

        this._youWonAmount = new PIXI.BitmapText("", {
            fontName : "NumbersHotNudge",
            fontSize : 40,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._youWonAmount.anchor = 0.5;
        this._youWonAmount.position.set(0, 0);

        this._fsCountTitle = new PIXI.Text(``, this._fsCountStyle);
        this._fsCountTitle.anchor.set(0.5, 0.5);
        this._fsCountTitle.position.set(0, 125);

        this._container.addChild(this._bgLights);
        this._container.addChild(this._youWonTitle);
        this._container.addChild(this._youWonAmount);
        this._container.addChild(this._fsCountTitle);

        return this._container;
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
    }

    protected startPresentation(data: WildNudgeParsedGameData, onShowComplete?: () => void): void {
        if (!data) {
            return;
        }

        this.updateTexts(data);

        // #317
        this._totalWinBelowStake = BelowStakeWinRestriction.isWinBelowStake(data.totalWin, (<ParsedGameData>data).playedBetValue);

            this._mainTimeline = new TimelineLite({paused : true});
            this._mainTimeline.add([
                () => {
                    SlotGame.sound.fadeAmbience(0, 3000);

                    // #317
                    if (!this._totalWinBelowStake) {
                        SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.FREE_SPIN_OUTRO);
                    }
                },
                TweenLite.fromTo(this._bgLights, 1, {alpha : 0}, {alpha : 1})
            ]);
            if(!this._totalWinBelowStake){
                this._mainTimeline.add([
                        TweenLite.to(this._youWonAmount, 1, {alpha : 1}),
                        TweenLite.to(this._fsCountTitle, 1, {alpha : 1}),
                        TweenLite.to(this._youWonTitle, 1, {alpha : 1})
                    ]
                );
            }else {
                this._mainTimeline.add([
                        TweenLite.to(this._youWonAmount, 1, {alpha : 1}),
                        TweenLite.to(this._fsCountTitle, 1, {alpha : 1})
                    ]
                );
            }

            this._mainTimeline.add(
                () => {
                    this._button.visible = true;
                    // this._autoCloseTimer.visible = true;
                    if(onShowComplete) {
                        onShowComplete();
                    }
                }
            );

            this._mainTimeline.add(() => {
                SlotGame.sound.playAmbience(WildNudgeSoundConfig.instance.MAIN_GAME_AMBIANCE);
                SlotGame.sound.fadeAmbience(1, 0);
            }, 5);

            this._mainTimeline.play(0);
    }

    private updateTexts(data: WildNudgeParsedGameData):void {
        this._youWonAmount.text = ` ${Currency.formatValue(data.totalWin)} `;
        this._fsCountTitle.text = ` ${Translation.translate(WildNudgeStrings.FS_SPINS_PLAYED)} ${data.numberOfFreespinsPlayed!.toString()} `;
    }

    protected stopPresentation(closeCallback?:() => void):void {
        if(this._mainTimeline.progress() < 1) {
            this._mainTimeline.progress(1);
        }
        super.stopPresentation(closeCallback);
        this.resetScreen();
    }

    private resetScreen():void {
        this._youWonAmount.alpha = 0;
        this._youWonTitle.alpha = 0;
        this._fsCountTitle.alpha = 0;
        this._bgLights.alpha = 0;

        this._button.visible = false;
        // this._autoCloseTimer.visible = false;
    }
}